import { adminGet, adminPost } from "@lib/adminApi";

import type {
  LegacyTransactionDetailResponse,
  NeedsAttentionResponse,
  RetrySettleResponse,
  SearchTransactionsParams,
  TransactionDetailResponse,
  TransactionListResponse,
  VoidTransactionResponse,
} from "./types";

export const fetchNeedsAttention = (): Promise<NeedsAttentionResponse> =>
  adminGet<NeedsAttentionResponse>("/admin/needs-attention");

export const searchTransactions = (
  params: SearchTransactionsParams,
): Promise<TransactionListResponse> => {
  const search = new URLSearchParams();
  if (params.statuses && params.statuses.length > 0) {
    search.set("status", params.statuses.join(","));
  }
  if (params.email) search.set("email", params.email);
  if (params.customerId) search.set("customerId", params.customerId);
  if (params.authorizedFrom) {
    search.set("authorizedFrom", params.authorizedFrom);
  }
  if (params.authorizedTo) {
    search.set("authorizedTo", params.authorizedTo);
  }
  search.set("limit", String(params.limit));
  search.set("offset", String(params.offset));
  search.set("sortOrder", params.sortOrder);
  return adminGet<TransactionListResponse>(`/admin/transactions?${search}`);
};

export const fetchTransactionDetail = (
  transactionId: string,
): Promise<TransactionDetailResponse> =>
  adminGet<TransactionDetailResponse>(
    `/admin/transactions/${encodeURIComponent(transactionId)}`,
  );

export const fetchLegacyTransactionDetail = (
  transactionId: string,
): Promise<LegacyTransactionDetailResponse> =>
  adminGet<LegacyTransactionDetailResponse>(
    `/admin/transactions/legacy/${encodeURIComponent(transactionId)}`,
  );

export const retrySettle = (
  transactionId: string,
): Promise<RetrySettleResponse> =>
  adminPost<RetrySettleResponse>(
    `/admin/transactions/${encodeURIComponent(transactionId)}/retry-settle`,
  );

export const voidTransaction = (
  transactionId: string,
  reason: string,
): Promise<VoidTransactionResponse> =>
  adminPost<VoidTransactionResponse>(
    `/admin/void-transaction/${encodeURIComponent(transactionId)}`,
    { reason },
  );
